import React from 'react';

import EmptyState from '@/pages/company/BankFeedRoute/components/EmptyStates/EmptyState';

// Thin wrapper passed to BankFeedGrid as its empty overlay — keeps a
// stable component identity (avoids inline-arrow remounts) while letting
// EmptyState own the actual layout shared with the other Bank Feed empty
// screens.
const NoFilterResults: React.FC = () => <EmptyState variant="no-filter-results" />;

export default NoFilterResults;
